import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  notifications: {
    position: 'fixed',
    bottom: '115px',
    right: '50px',
    zIndex: 10000,
    [theme.breakpoints.down('sm')]: {
      right: '28px',
      zIndex: 1200, // Overlaps Dialog component when it's fullWidth
    },
  },
  stack: {
    position: 'absolute',
    bottom: -40,
    right: 0,
    [theme.breakpoints.down('sm')]: {
      bottom: -75,
      width: 'calc(100vw - 44px)',
    },
  },
  text: {
    fontSize: '14px',
    lineHeight: '20px',
    width: 360,
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
    },
  },
  content: {
    background: theme.tokens.colors.bg.dark.primary,
    color: theme.tokens.colors.bg.light.primary,
    borderRadius: '16px',
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
  },
  wrapper: {
    borderRadius: '16px',
    boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.1)',
    maxHeight: '310px',
    overflow: 'auto',
  },
  inner: {
    borderRadius: '16px',
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,
  },
}));
